<template>
    <SiteSection sectionId="section-qa"
                 sectionNo="5"
                 label="QA 專區"
                 title="Question? Looks Here!"
    >
        <div class="content-container">
            <Question></Question>
        </div>
    </SiteSection>
</template>

<script>
import SiteSection from "./source/Section.vue";
import ContentBlock from "./source/ContentBlock.vue";
import Question from "./sectionQuestion/Question.vue"

export default {
    name: 'SectionQuestion',
    components: {
        SiteSection,
        ContentBlock,
        Question
    }
}
</script>

<style scoped
       lang="scss">
    @import "../static/styles/palette.scss";

    .section {
        background-color: $blue;

        .content-container {
            width: 925px;
            margin: 32px auto 80px auto;
        }

        @media all and (max-width: 1200px) {
            .content-container {
                width: 80%;
            }
        }

        @media all and (max-width: 960px) {
            .content-container {
                width: calc(100% - 120px);
            }
        }

        @media all and (max-width: 768px) {
            .content-container {
                width: calc(100% - 70px);
            }
        }

        @media all and (max-width: 480px) {
            .content-container {

                width: calc(100% - 60px);
            }
        }

        @media all and (max-width: 320px) {
            .content-container {

                width: calc(100% - 40px);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// SectionQuestion.vue?7fca40ec